import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function SectionHeader({
  icon,
  iconBg = "bg-slate-100",
  iconColor = "text-slate-600",
  title,
  subtitle,
  badge,
}) {
  return (
    <div className="flex items-center justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        <div
          className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-2xl ${iconBg} ${iconColor}`}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <div>
          <h2 className="text-base font-semibold text-slate-900">{title}</h2>
          {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
        </div>
      </div>
      {badge || null}
    </div>
  );
}
